import React, { useState } from 'react';
import { Layout } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { BrowserRouter as Router } from 'react-router-dom';
import { useStateValue } from '../providers/StateProvider';
import HelpMenu from '../components/general/HelpMenu';
import AccountMenuAuditor from '../components/general/AccountMenuAuditor';
import FooterContent from './FooterContent';
import AvisoPrivacidad from './avisoPrivacidad/AvisoPrivacidad';

const { Header, Content } = Layout;

const HomeAvisoPrivacidad = () => {
    const [{ theme, broken, puestoNombre }] = useStateValue();
    const [collapsed, setCollapsed] = useState(false);

    return (
        <Router>
            <Layout style={{ minHeight: '100vh', overflow: 'hidden' }}>
                <Header style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', backgroundColor: theme === 'light' ? '#fff' : '' }}>
                    <div>
                        {broken
                            ? <MenuOutlined style={{ color: theme === 'dark' ? '#fff' : '' }} onClick={() => setCollapsed(!collapsed)} />
                            : <h4 className={`${ theme === 'dark' ? 'text-white' : '' } mt-2`}>{puestoNombre}</h4>}
                    </div>
                    <div>
                        <HelpMenu />
                        <AccountMenuAuditor />
                    </div>
                </Header>
                <Content style={{ margin: '24px 16px', padding: 24, minHeight: 'calc(100vh - 114px)', background: '#fff' }}>
                    <AvisoPrivacidad />
                </Content>
                <FooterContent />
            </Layout>
        </Router>
    );
};
export default HomeAvisoPrivacidad;
